interface ConfigBadgeProps {
  label: string;
  active: boolean;
}

export function ConfigBadge({ label, active }: ConfigBadgeProps) {
  return (
    <span
      className={`px-3 py-1 rounded-full text-sm font-medium ${
        active
          ? "bg-green-100 text-green-700 border border-green-300"
          : "bg-gray-100 text-gray-500 border border-gray-200"
      }`}
    >
      {label}
    </span>
  );
}
